import { Container } from './style';

export const Button = (props: any) => (
	<Container>
		<button onClick={props.onClick} className={props.className}>
			{props.children}
		</button>
	</Container>
);
